import cms                      from 'lib/api/cms';
import { IFeatureFlag }         from 'types/featureFlag';

export default function getFeatureFlag(name: string, fallback: boolean): Promise<boolean> {
  return cms.get<IFeatureFlag>(`/cms/feature/flag/${name}`)
    .then(response => response.value)
    .catch(() => fallback)
}
